function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import utils from './utils';
import { Switch } from './components/components';
var Danmaku = function () {
    function Danmaku(options, player) {
        var _this = this;
        _classCallCheck(this, Danmaku);
        _defineProperty(this, 'checkShield', function (dan) {
            var type = typeof dan.type !== 'string' ? utils.number2Type(dan.type) : dan.type;
            var origin = dan.origin;
            if ((_this[''.concat(type, 'Limit')] || _this[''.concat(origin, 'Limit')]) && !/(\/n)|(\\n)/i.test(dan.text)) {
                return false;
            }
            return true;
        });
        this.options = options;
        this.player = player;
        this.createHash = utils.initHash();
        this.tunnelPadding = 6;
        this.container = this.options.container;
        this.danTunnel = {
            right: {},
            left: {},
            top: {},
            bottom: {}
        };
        this.tunnelHeights = {
            right: [],
            left: [],
            top: [],
            bottom: []
        };
        this.danCount = {
            unknown: 0,
            mfuns: 0,
            bili: 0,
            acfun: 0
        };
        this.danData = {
            unknown: null,
            mfuns: null,
            bili: null,
            acfun: null
        };
        this.danIndex = 0;
        this.drawIndex = 0;
        this.dan = [];
        this.showing = this.options.isShow;
        this._opacity = this.options.opacity;
        this._fontScale = this.options.fontScale;
        this._speed = this.options.speed;
        this._limitArea = this.options.limitArea;
        this.events = this.options.events;
        this.topLimit = false;
        this.bottomLimit = false;
        this.leftLimit = false;
        this.rightLimit = false;
        this.colorLimit = false;
        this.advanceLimit = false;
        this.mfunsLimit = false;
        this.biliLimit = false;
        this.acfunLimit = false;
        this.unknownLimit = false;
        this.originFilter = new Set();
        this.unlimited = this.options.unlimited;
        this.loaded = false;
        this.paused = true;
        this.danmakuCheck = false;
        this.danmakuTip = this.player.template.danmakuTip;
        this.danmakuTipBox = this.player.template.danmakuTipBox;
        this.currentX = 0;
        this.currentY = 0;
        this.danmakuCatch = this.options.danmakuCatch;
        this.reportReason = null;
        this._measure('');
        this.load();
        this.initDanmakuTips();
    }
    _createClass(Danmaku, [
        {
            key: 'initDanmakuTips',
            value: function initDanmakuTips() {
                var _this2 = this;
                var danmakuTipMaskMove = function danmakuTipMaskMove(e) {
                    var distance = Math.sqrt(Math.pow(e.pageX - _this2.currentX, 2) + Math.pow(e.pageY - _this2.currentY, 2));
                    if (distance > _this2.player.options.danmaku.sensitivity) {
                        _this2.currentX = e.pageX;
                        _this2.currentY = e.pageY;
                        return;
                    }
                    _this2.currentX = e.pageX;
                    _this2.currentY = e.pageY;
                    var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
                    var scrollY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                    var items = _this2.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        var boundingClientRect = item.getBoundingClientRect();
                        var danLeft = boundingClientRect.left + scrollX;
                        var danRight = boundingClientRect.right + scrollX;
                        var danTop = boundingClientRect.top + scrollY;
                        var danBottom = boundingClientRect.bottom + scrollY;
                        if (danLeft < e.pageX && e.pageX < danRight && danTop < e.pageY && e.pageY < danBottom) {
                            _this2.currentLockDanmaku = item;
                            _this2.lockDanmakuData = _this2.getDanmakuData(item.dataset.id);
                            if (_this2.player.options.uid === +_this2.lockDanmakuData.author) {
                                _this2.player.template.danmakuCancel.classList.add('show');
                                _this2.player.template.danmakuReport.classList.remove('show');
                            } else {
                                _this2.player.template.danmakuCancel.classList.remove('show');
                                _this2.player.template.danmakuReport.classList.add('show');
                            }
                            item.classList.add('lock');
                            _this2.danmakuTip.classList.add('show');
                            var itemTop = danTop - _this2.container.getBoundingClientRect().top - scrollY;
                            _this2.danmakuTip.style.top = itemTop + 5 + 'px';
                            _this2.danmakuTip.style.height = 45 + item.offsetHeight + 'px';
                            if (e.pageX - _this2.container.getBoundingClientRect().left < 75) {
                                _this2.danmakuTip.style.left = -scrollX;
                            } else if (_this2.container.clientWidth - (e.pageX - _this2.container.getBoundingClientRect().left) < 75) {
                                _this2.danmakuTip.style.left = 'auto';
                                _this2.danmakuTip.style.right = -scrollX;
                            } else {
                                _this2.danmakuTip.style.left = e.pageX - _this2.container.getBoundingClientRect().left - 75 - scrollX + 'px';
                            }
                            break;
                        } else {
                            item.classList.remove('lock');
                        }
                    }
                };
                this.danmakuTip.addEventListener('mouseover', function () {
                    _this2.player.template.danmakuTipMask.removeEventListener('mousemove', danmakuTipMaskMove);
                });
                this.danmakuTip.addEventListener('mouseleave', function () {
                    _this2.danmakuTip.classList.remove('show');
                    _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                    _this2.player.template.danmakuTipMask.addEventListener('mousemove', danmakuTipMaskMove);
                });
                this.player.template.danmakuTipMask.addEventListener('mousemove', danmakuTipMaskMove);
                this.player.template.danmakuTipBox.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
                this.player.template.danmakuPraise.addEventListener('click', function (e) {
                });
                this.player.template.danmakuCopy.addEventListener('click', function (e) {
                    navigator && navigator.clipboard && navigator.clipboard.writeText(_this2.lockDanmakuData.text).then(function (res) {
                        _this2.player.notice('已复制');
                        _this2.danmakuTip.classList.remove('show');
                    })['catch'](function (err) {
                        console.log(err);
                    });
                });
                this.player.template.danmakuCancel.addEventListener('click', function (e) {
                });
                this.player.template.danmakuReport.addEventListener('click', function () {
                    return _this2.report();
                });
                this.player.template.danmakuReportSubmit.addEventListener('click', function () {
                    if (_this2.player.template.danmakuReportSubmit.classList.contains('disable'))
                        return;
                    var _this2$lockDanmakuDat = _this2.lockDanmakuData, author = _this2$lockDanmakuDat.author, text = _this2$lockDanmakuDat.text, origin = _this2$lockDanmakuDat.origin;
                    var id = _this2.options.api.id;
                    console.log(_this2.lockDanmakuData);
                    var reportData = {
                        danId: id !== null && id !== void 0 ? id : null,
                        author: author !== null && author !== void 0 ? author : null,
                        text: text,
                        reason: _this2.reportReason || _this2.player.template.danmakuReportDetail.value
                    };
                    if (origin === 'mfuns')
                        _this2.player.events.trigger('danmaku_report', reportData);
                    else
                        _this2.player.notice('不能跨站执法哦~');
                    _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                    _this2.player.template.danmakuReportMask.classList.remove('show');
                    _this2.player.template.danmakuReportDetail.classList.remove('show');
                });
            }
        },
        {
            key: 'report',
            value: function report() {
                var _this3 = this;
                setTimeout(function () {
                    _this3.currentLockDanmaku && _this3.currentLockDanmaku.classList.add('lock');
                }, 50);
                this.player.template.danmakuReportMask.classList.add('show');
                this.player.template.danmakuReportContent.innerHTML = this.lockDanmakuData.text;
                this.player.template.danmakuReportMask.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
                this.player.template.danmakuReportModelClose.addEventListener('click', function (e) {
                    _this3.currentLockDanmaku && _this3.currentLockDanmaku.classList.remove('lock');
                    _this3.player.template.danmakuReportMask.classList.remove('show');
                    _this3.player.template.danmakuReportDetail.classList.remove('show');
                });
                var allReports = this.player.template.danmakuReportMask.querySelectorAll('.mfunsPlayer-switch');
                allReports.forEach(function (el, index) {
                    if (!_this3['reportOption'.concat(index)]) {
                        _this3['reportOption'.concat(index)] = new Switch({
                            el: el,
                            value: false,
                            onToggle: function onToggle(value) {
                                if (value) {
                                    for (var i = 0; i < allReports.length; i++) {
                                        i !== index && _this3['reportOption'.concat(i)].setValue(false);
                                    }
                                    if (el.children[1].innerHTML !== '其他') {
                                        _this3.reportReason = el.children[1].innerHTML;
                                        _this3.player.template.danmakuReportDetail.classList.remove('show');
                                        _this3.player.template.danmakuReportSubmit.classList.remove('disable');
                                    } else {
                                        _this3.reportReason = '';
                                        _this3.player.template.danmakuReportDetail.classList.add('show');
                                        _this3.player.template.danmakuReportDetail.value = '';
                                    }
                                } else {
                                    _this3.player.template.danmakuReportDetail.classList.contains('show') && _this3.player.template.danmakuReportDetail.classList.remove('show');
                                }
                            }
                        });
                    } else {
                        _this3['reportOption'.concat(index)].setValue(false);
                    }
                });
                this.player.template.danmakuReportDetail.addEventListener('input', function (e) {
                    _this3.player.template.danmakuReportSubmit.classList[e.target.value.trim() ? 'remove' : 'add']('disable');
                });
            }
        },
        {
            key: 'load',
            value: function load() {
                var _this4 = this;
                var _JSON$parse = JSON.parse(JSON.stringify(this.options.api)), address = _JSON$parse.address, danmakuAddition = _JSON$parse.danmakuAddition, id = _JSON$parse.id, advDanApi = _JSON$parse.advDanApi, otherDanParams = _JSON$parse.otherDanParams;
                var apiurl = ''.concat(address, '?id=').concat(id).concat(otherDanParams);
                this.endpoints = danmakuAddition || [];
                var advDanData = [];
                id && address && this.endpoints.push({
                    url: apiurl,
                    type: 'dplayer-danmaku',
                    origin: 'mfuns'
                });
                advDanApi && this.endpoints.push({
                    url: ''.concat(advDanApi.address, '/v1/advdanmaku?id=').concat(advDanApi.id),
                    type: 'mfuns-advDanmaku-oldApi'
                });
                this.events && this.events.trigger('danmaku_load_start', this.endpoints);
                this.player.template.danmakuSource.classList.add('loading');
                this.loaded = false;
                this.endpoints.forEach(function (el) {
                    if (!el.origin) {
                        switch (el.type) {
                        case 'bili-danmaku':
                            el.origin = 'bili';
                            break;
                        case 'acfun-danmaku':
                            el.origin = 'acfun';
                            break;
                        default:
                            el.origin = 'unknown';
                        }
                    }
                });
                this._readAllEndpoints(this.endpoints, function (results, loadStatus) {
                    _this4.player.template.danmakuSource.classList.remove('loading');
                    if (!loadStatus) {
                        _this4.events && _this4.events.trigger('danmaku_load_end', []);
                        return _this4.options.error(results);
                    } else {
                        _this4.dan = [].concat.apply([], results).sort(function (a, b) {
                            return a.time - b.time;
                        });
                        _this4.dan.forEach(function (d) {
                            d.id = _this4.createHash(8);
                            if (d.type == 8) {
                                advDanData.push(d.text);
                            }
                            _this4.danCount[d.origin]++;
                        });
                        _this4.events && _this4.events.trigger('danmaku_load_end', _this4.dan);
                        _this4.loaded = true;
                        window.requestAnimationFrame(function () {
                            _this4.frame();
                        });
                        _this4.options.callback(_this4.dan.length, advDanData);
                    }
                });
            }
        },
        {
            key: 'reload',
            value: function reload(newId, newAdvDanApi, newAddition) {
                var _this5 = this;
                this.player.template.danmakuCount.innerHTML = '弹幕装填中...';
                if (newId) {
                    this.options.api.id = newId;
                }
                if (newAddition) {
                    this.options.api.danmakuAddition = newAddition;
                }
                if (newAdvDanApi) {
                    this.options.api.advDanApi = newAdvDanApi;
                }
                [
                    'mfuns',
                    'bili',
                    'acfun',
                    'unknown'
                ].forEach(function (el) {
                    var currentOrigin = _this5.player.template['danmakuSource_'.concat(el)];
                    var originCount = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-count');
                    currentOrigin.classList.replace('success', 'nodata');
                    currentOrigin.classList.replace('error', 'nodata');
                    originCount.innerHTML = '-';
                });
                this.dan = [];
                this.danCount = {
                    unknown: 0,
                    mfuns: 0,
                    bili: 0,
                    acfun: 0
                };
                this.danData = {
                    unknown: null,
                    mfuns: null,
                    bili: null,
                    acfun: null
                };
                this.clear();
                this.load();
            }
        },
        {
            key: 'reloadEndPoints',
            value: function reloadEndPoints(origin) {
                var _this6 = this;
                var currentEndPoints = [];
                this.player.template.danmakuCount.innerHTML = '弹幕装填中...';
                this.endpoints.forEach(function (el) {
                    if (el.origin === origin) {
                        currentEndPoints.push(el);
                    }
                });
                this.events && this.events.trigger('danmaku_load_start', this.endpoints);
                this._readAllEndpoints(currentEndPoints, function (results, loadStatus) {
                    if (!loadStatus) {
                        _this6.events && _this6.events.trigger('danmaku_load_end', []);
                        _this6.options.error(results, true);
                    } else {
                        var _this6$danData = _this6.danData, acfun = _this6$danData.acfun, bili = _this6$danData.bili, mfuns = _this6$danData.mfuns, unknown = _this6$danData.unknown;
                        _this6.dan = [].concat(_toConsumableArray(acfun !== null && acfun !== void 0 ? acfun : []), _toConsumableArray(bili !== null && bili !== void 0 ? bili : []), _toConsumableArray(mfuns !== null && mfuns !== void 0 ? mfuns : []), _toConsumableArray(unknown !== null && unknown !== void 0 ? unknown : [])).sort(function (a, b) {
                            return a.time - b.time;
                        });
                        _this6.dan.forEach(function (d) {
                            d.id = _this6.createHash(8);
                            if (d.type == 8) {
                                advDanData.push(d.text);
                            }
                            _this6.danCount[d.origin]++;
                        });
                        _this6.events && _this6.events.trigger('danmaku_load_end', _this6.dan);
                        _this6.loaded = true;
                        _this6.options.callback(_this6.dan.length, null, true);
                    }
                });
            }
        },
        {
            key: '_readAllEndpoints',
            value: function _readAllEndpoints(endpoints, callback) {
                var _this7 = this;
                var allRequests = endpoints.map(function (link) {
                    return new Promise(function (resolve, reject) {
                        _this7.options.apiBackend.read({
                            url: link.url,
                            type: link.type,
                            origin: link.origin,
                            success: function success(data) {
                                _this7.danData[''.concat(link.origin)] = data;
                                var currentOrigin = _this7.player.template['danmakuSource_'.concat(link.origin)];
                                var originCount = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-count');
                                var originOperate = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-operate');
                                currentOrigin.classList.replace('nodata', 'success');
                                currentOrigin.classList.replace('error', 'success');
                                originCount.innerHTML = data.length;
                                originOperate.onclick = function () {
                                    if (currentOrigin.classList.contains('forbidden')) {
                                        currentOrigin.classList.replace('forbidden', 'success');
                                        _this7[''.concat(link.origin, 'Limit')] = false;
                                        _this7.originFilter['delete'](link.origin);
                                        _this7.events && _this7.events.trigger('danmaku_filter', {
                                            key: 'origin',
                                            value: _toConsumableArray(_this7.originFilter)
                                        });
                                    } else {
                                        currentOrigin.classList.replace('success', 'forbidden');
                                        _this7[''.concat(link.origin, 'Limit')] = true;
                                        var items = _this7.container.querySelectorAll('.mfunsPlayer-danmaku-item');
                                        items.forEach(function (el) {
                                            if (el.dataset.origin === link.origin) {
                                                el.innerHTML = '';
                                            }
                                        });
                                        _this7.originFilter.add(link.origin);
                                        _this7.events && _this7.events.trigger('danmaku_filter', {
                                            key: 'origin',
                                            value: _toConsumableArray(_this7.originFilter)
                                        });
                                    }
                                };
                                resolve(data);
                            },
                            error: function error(_error) {
                                var currentOrigin = _this7.player.template['danmakuSource_'.concat(link.origin)];
                                var originOperate = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-operate');
                                currentOrigin.classList.replace('nodata', 'error');
                                originOperate.addEventListener('click', function () {
                                    _this7.reloadEndPoints(link.origin);
                                });
                                reject(_error);
                            }
                        });
                    });
                });
                Promise.all(_toConsumableArray(allRequests)).then(function (res) {
                    callback(res, 1);
                })['catch'](function (err) {
                    console.log(err);
                    callback(err, 0, origin);
                });
            }
        },
        {
            key: 'send',
            value: function send(dan) {
                var _dan$type, _dan$color, _dan$size;
                var newDanmakuId = this.createHash(8);
                var danmakuData = {
                    time: this.options.time() + 0.2,
                    size: +dan.size || 25,
                    author: this.player.options.uid,
                    id: newDanmakuId,
                    text: dan.text,
                    color: dan.color || 16777215,
                    type: dan.type || 'right'
                };
                var danmaku = {
                    text: this.htmlEncode(danmakuData.text),
                    color: danmakuData.color,
                    size: danmakuData.size,
                    type: danmakuData.type,
                    id: newDanmakuId,
                    isSubtitle: /(\/n)|(\\n)/i.test(danmakuData.text),
                    border: '2px solid '.concat(this.options.borderColor)
                };
                this.dan.splice(this.danIndex, 0, danmakuData);
                this.danIndex++;
                this.draw(danmaku);
                this.options.sendDanmaku && this.options.sendDanmaku([
                    +this.options.time().toFixed(2),
                    utils.type2Number((_dan$type = dan.type) !== null && _dan$type !== void 0 ? _dan$type : 'right'),
                    utils.color2Number((_dan$color = dan.color) !== null && _dan$color !== void 0 ? _dan$color : '#FFFFFF'),
                    dan.text,
                    (_dan$size = +dan.size) !== null && _dan$size !== void 0 ? _dan$size : 25
                ], this.options.videoIndex());
                this.events && this.events.trigger('danmaku_send', danmakuData);
            }
        },
        {
            key: 'getDanmakuData',
            value: function getDanmakuData(id) {
                var dan;
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].id === id) {
                        dan = this.dan[i];
                        break;
                    }
                }
                return dan;
            }
        },
        {
            key: 'frame',
            value: function frame() {
                var _this8 = this;
                if (this.dan.length && !this.paused && this.showing) {
                    var item = this.dan[this.danIndex];
                    var dan = [];
                    while (item && this.options.time() > parseFloat(item.time)) {
                        if (this.checkShield(item)) {
                            dan.push(item);
                        }
                        item = this.dan[++this.danIndex];
                    }
                    if (this.colorLimit) {
                        dan = dan.filter(function (el) {
                            return el.color === 16777215;
                        });
                    }
                    if (this.miniMode) {
                        dan = dan.map(function (el) {
                            return Object.assign(el, { size: 16 });
                        });
                    }
                    if (dan.length) {
                        this.draw(dan, this.drawIndex + 1);
                        this.drawIndex++;
                    }
                }
                window.requestAnimationFrame(function () {
                    _this8.frame();
                });
            }
        },
        {
            key: 'limitArea',
            value: function limitArea(areaType) {
                if (areaType === 'keepOutSubtitle') {
                    this.keepOutSubtitle = true;
                    this.container.style.bottom = '20%';
                    return;
                } else if (areaType === 'notKeepOutSubtitle') {
                    this.keepOutSubtitle = false;
                    this.container.style.bottom = '0';
                    return;
                }
                this._limitArea = Math.min(areaType / 4, 1);
                this.shield('bottom', areaType < 4, true);
                this.unlimited = areaType > 4;
                this.events && this.events.trigger('setDanmaku', {
                    key: 'limitArea',
                    value: areaType
                });
            }
        },
        {
            key: 'shield',
            value: function shield(type) {
                var _this9 = this;
                var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var noListen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                this[''.concat(type, 'Limit')] = flag;
                if (flag) {
                    this.clear(type);
                    var forbidDanmaku = this.container.querySelectorAll('.mfunsPlayer-danmaku-'.concat(type));
                    forbidDanmaku.forEach(function (el) {
                        if (!el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        }
                    });
                }
                if (type === 'color') {
                    var items = this.container.querySelectorAll('.mfunsPlayer-danmaku-item');
                    items.forEach(function (el) {
                        if (el.style.color !== 'rgb(255, 255, 255)' && !el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        }
                    });
                }
                if (type === 'special') {
                }
                var filterArr = [];
                var allType = [
                    'top',
                    'bottom',
                    'left',
                    'right',
                    'color',
                    'special'
                ];
                allType.forEach(function (el) {
                    if (_this9[''.concat(el, 'Limit')]) {
                        filterArr.push(el);
                    }
                });
                this.events && !noListen && this.events.trigger('setDanmaku', {
                    key: 'shields',
                    value: filterArr
                });
                this.events && !noListen && this.events.trigger('danmaku_filter', {
                    key: 'type',
                    value: filterArr
                });
            }
        },
        {
            key: 'opacity',
            value: function opacity(percentage) {
                if (percentage !== undefined) {
                    var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].classList.contains('subtitle'))
                            continue;
                        items[i].style.opacity = percentage;
                    }
                    this._opacity = percentage;
                    this.events && this.events.trigger('setDanmaku', {
                        key: 'opacity',
                        value: percentage
                    });
                }
                return this._opacity;
            }
        },
        {
            key: 'size',
            value: function size(scale) {
                this._fontScale = scale;
                this.events && this.events.trigger('setDanmaku', {
                    key: 'fontScale',
                    value: Number(scale.toFixed(2))
                });
                return this._fontScale;
            }
        },
        {
            key: 'speed',
            value: function speed(_speed) {
                var speedName;
                if (_speed !== undefined) {
                    switch (_speed) {
                    case 0.5:
                        speedName = 'lowest';
                        break;
                    case 0.75:
                        speedName = 'low';
                        break;
                    case 1:
                        speedName = '';
                        break;
                    case 1.25:
                        speedName = 'fast';
                        break;
                    case 1.5:
                        speedName = 'fastest';
                        break;
                    default:
                        break;
                    }
                    var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-move');
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].classList.contains('subtitle'))
                            continue;
                        if (!!speedName) {
                            items[i].classList.add(speedName);
                        }
                        if (!!this._speed) {
                            items[i].classList.remove(this._speed);
                        }
                    }
                }
                this._speed = speedName;
                this._speedVal = _speed;
                this.events && this.events.trigger('setDanmaku', {
                    key: 'speed',
                    value: _speed
                });
            }
        },
        {
            key: 'draw',
            value: function draw(dan, index) {
                var _this10 = this;
                if (this.showing) {
                    var itemHeight = this.options.height * this._fontScale;
                    var danWidth = this.container.offsetWidth;
                    var danHeight = this.container.offsetHeight * this._limitArea;
                    var itemY = Math.floor(danHeight / itemHeight);
                    if (this.tunnelHeights.right.length !== itemY)
                        this.tunnelHeights.right = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.left.length !== itemY)
                        this.tunnelHeights.left = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.top.length !== itemY)
                        this.tunnelHeights.top = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.bottom.length !== itemY)
                        this.tunnelHeights.bottom = utils.createArray(itemY, itemHeight);
                    var danItemRight = function danItemRight(ele, istest) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleRight = ele.getBoundingClientRect().right || _this10.container.getBoundingClientRect().right + eleWidth;
                        if (istest) {
                            console.dir(ele.offsetWidth);
                        }
                        return _this10.container.getBoundingClientRect().right - eleRight;
                    };
                    var danItemLeft = function danItemLeft(ele) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleLeft = ele.getBoundingClientRect().left || _this10.container.getBoundingClientRect().left - eleWidth;
                        return eleLeft - _this10.container.getBoundingClientRect().left;
                    };
                    var danSpeed = function danSpeed(width) {
                        var _this10$_speedVal;
                        return ((danWidth + width) / _this10.player.fullScreen.isFullScreen() ? 8 : 5) * ((_this10$_speedVal = _this10._speedVal) !== null && _this10$_speedVal !== void 0 ? _this10$_speedVal : 1);
                    };
                    var realDOMTunnel = function realDOMTunnel(type, i) {
                        return _toConsumableArray(_this10.container.querySelectorAll('.mfunsPlayer-danmaku-'.concat(type))).filter(function (el) {
                            return el.dataset.tunnel === ''.concat(i);
                        });
                    };
                    var tunnelPush = {
                        right: {},
                        left: {},
                        bottom: {},
                        top: {}
                    };
                    var getTunnel = function getTunnel(ele, type, width) {
                        var tmp = danWidth / danSpeed(width);
                        var _loop = function _loop(i) {
                            var item = _this10.danTunnel[type][i + ''];
                            if (item && item.length) {
                                if (type !== 'right' && type !== 'left') {
                                    return 'continue';
                                }
                                for (var j = 0; j < item.length; j++) {
                                    if (type === 'right') {
                                        var danRight = danItemRight(item[j]) - 10;
                                        _this10.tunnelHeights[type][i] = parseInt(item[j].style.fontSize) + _this10.tunnelPadding;
                                        if (danRight <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danRight <= 0) {
                                            break;
                                        }
                                    }
                                    if (type === 'left') {
                                        var danLeft = danItemLeft(item[j]) - 10;
                                        _this10.tunnelHeights[type][i] = parseInt(item[j].style.fontSize) + _this10.tunnelPadding;
                                        if (danLeft <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danLeft <= 0) {
                                            break;
                                        }
                                    }
                                    if (j === item.length - 1) {
                                        if (tunnelPush[type] && tunnelPush[type][i + ''] && !_this10.unlimited) {
                                            break;
                                        }
                                        _this10.danTunnel[type][i + ''].push(ele);
                                        tunnelPush[type][i + ''] = true;
                                        ele.addEventListener('animationend', function () {
                                            var _this10$danTunnel$typ, _this10$danTunnel$typ2;
                                            var index = (_this10$danTunnel$typ = _this10.danTunnel[type][i + '']) === null || _this10$danTunnel$typ === void 0 ? void 0 : _this10$danTunnel$typ.indexOf(ele);
                                            Object.keys(_this10.danTunnel[type]).length > 0 && ((_this10$danTunnel$typ2 = _this10.danTunnel[type][i + '']) === null || _this10$danTunnel$typ2 === void 0 ? void 0 : _this10$danTunnel$typ2.splice(index, 1));
                                        });
                                        return { v: i };
                                    }
                                }
                            } else {
                                if (tunnelPush[type] && tunnelPush[type][i + ''] && !_this10.unlimited) {
                                    return 'break';
                                }
                                if (Array.isArray(_this10.danTunnel[type][i + ''])) {
                                    _this10.danTunnel[type][i + ''].push(ele);
                                } else {
                                    _this10.danTunnel[type][i + ''] = [ele];
                                }
                                tunnelPush[type][i + ''] = true;
                                ele.addEventListener('animationend', function () {
                                    var _this10$danTunnel$typ3, _this10$danTunnel$typ4;
                                    var index = (_this10$danTunnel$typ3 = _this10.danTunnel[type][i + '']) === null || _this10$danTunnel$typ3 === void 0 ? void 0 : _this10$danTunnel$typ3.indexOf(ele);
                                    Object.keys(_this10.danTunnel[type]).length > 0 && ((_this10$danTunnel$typ4 = _this10.danTunnel[type][i + '']) === null || _this10$danTunnel$typ4 === void 0 ? void 0 : _this10$danTunnel$typ4.splice(index, 1));
                                });
                                return { v: i };
                            }
                        };
                        for (var i = 0; _this10.unlimited || i < itemY; i++) {
                            var _ret = _loop(i);
                            if (_ret === 'continue')
                                continue;
                            if (_ret === 'break')
                                break;
                            if (_typeof(_ret) === 'object')
                                return _ret.v;
                        }
                        return -1;
                    };
                    if (Object.prototype.toString.call(dan) !== '[object Array]') {
                        dan = [dan];
                    }
                    var docFragment = document.createDocumentFragment();
                    var _loop2 = function _loop2() {
                        var _dan$i$size;
                        if (!dan[i].color) {
                            dan[i].color = 16777215;
                        }
                        if (!dan[i].size) {
                            dan[i].size = 25;
                        }
                        var item = document.createElement('div');
                        if (!_this10.paused) {
                            item.classList.add('mfunsPlayer-danmaku-run');
                        } else {
                            item.classList.remove('mfunsPlayer-danmaku-run');
                        }
                        item.classList.add('mfunsPlayer-danmaku-item');
                        item.classList.add('mfunsPlayer-danmaku-'.concat(dan[i].type));
                        dan[i].isSubtitle = /(\/n)|(\\n)/i.test(dan[i].text);
                        dan[i].isSubtitle && item.classList.add('subtitle');
                        if (dan[i].border) {
                            item.innerHTML = '<span style="border:'.concat(dan[i].border, '">').concat(dan[i].text.replace(/(\/n)|(\\n)/g, '\n'), '</span>');
                        } else {
                            item.innerHTML = '<span>'.concat(dan[i].text.replace(/(\/n)|(\\n)/g, '\n'), '</span>');
                        }
                        if (typeof dan[i].color !== 'string') {
                            item.style.color = utils.number2Color(dan[i].color);
                        } else {
                            item.style.color = dan[i].color;
                        }
                        item.style.opacity = _this10._opacity;
                        item.style.fontSize = +dan[i].size * (dan[i].isSubtitle ? 1 : _this10._fontScale) + 'px';
                        item.addEventListener('animationend', function () {
                            _toConsumableArray(_this10.container.children).includes(item) && _this10.container.removeChild(item);
                        });
                        var itemWidth = _this10._measure(dan[i].text, (_dan$i$size = +dan[i].size) !== null && _dan$i$size !== void 0 ? _dan$i$size : 25);
                        var tunnel, realTunnel;
                        switch (dan[i].type) {
                        case 'right':
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var maxTop = _this10.tunnelHeights.right.slice(0, itemY).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                var top = _this10.tunnelHeights.right.slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0) % maxTop;
                                if (top + parseInt(item.style.fontSize) + _this10.tunnelPadding > danHeight) {
                                    var _this10$danTunnel$dan;
                                    (_this10$danTunnel$dan = _this10.danTunnel[dan[i].type][tunnel]) === null || _this10$danTunnel$dan === void 0 ? void 0 : _this10$danTunnel$dan.pop();
                                    return 'continue';
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = (dan[i].isSubtitle ? 0 : top) + 'px';
                                item.style.transform = 'translateX(-'.concat(danWidth, 'px)');
                            }
                            break;
                        case 'left':
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var _maxTop = _this10.tunnelHeights.left.slice(0, itemY).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                var _top = _this10.tunnelHeights.left.slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0) % _maxTop;
                                if (_top + parseInt(item.style.fontSize) + _this10.tunnelPadding > danHeight) {
                                    var _this10$danTunnel$dan2;
                                    (_this10$danTunnel$dan2 = _this10.danTunnel[dan[i].type][tunnel]) === null || _this10$danTunnel$dan2 === void 0 ? void 0 : _this10$danTunnel$dan2.pop();
                                    return 'continue';
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = (dan[i].isSubtitle ? 0 : _top) + 'px';
                                item.style.transform = 'translateX('.concat(danWidth, 'px)');
                            }
                            break;
                        case 'top':
                            tunnel = getTunnel(item, dan[i].type) % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var topArr = [];
                                var topDan = _this10.danTunnel.top;
                                for (var key in topDan) {
                                    topArr.push.apply(topArr, _toConsumableArray(topDan[key]));
                                }
                                var _top2 = topArr.map(function (el) {
                                    return parseInt(el.style.fontSize) + _this10.tunnelPadding;
                                }).slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                if (_top2 + parseInt(item.style.fontSize) + _this10.tunnelPadding > danHeight) {
                                    var _this10$danTunnel$dan3;
                                    (_this10$danTunnel$dan3 = _this10.danTunnel[dan[i].type][i + '']) === null || _this10$danTunnel$dan3 === void 0 ? void 0 : _this10$danTunnel$dan3.pop();
                                    return { v: void 0 };
                                }
                                item.dataset.tunnel = tunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.marginLeft = '-'.concat((itemWidth + 1) * 0.5, 'px');
                                item.style.top = (dan[i].isSubtitle ? 0 : _top2) + 'px';
                            }
                            break;
                        case 'bottom':
                            tunnel = getTunnel(item, dan[i].type) % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var bottomArr = [];
                                var bottomDan = _this10.danTunnel.bottom;
                                for (var _key in bottomDan) {
                                    bottomArr.push.apply(bottomArr, _toConsumableArray(bottomDan[_key]));
                                }
                                var bottom = bottomArr.map(function (el) {
                                    return parseInt(el.style.fontSize) + _this10.tunnelPadding;
                                }).slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                if (bottom + parseInt(item.style.fontSize) + _this10.tunnelPadding > danHeight) {
                                    var _this10$danTunnel$dan4;
                                    (_this10$danTunnel$dan4 = _this10.danTunnel[dan[i].type][i + '']) === null || _this10$danTunnel$dan4 === void 0 ? void 0 : _this10$danTunnel$dan4.pop();
                                    return { v: void 0 };
                                }
                                item.dataset.tunnel = tunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.marginLeft = '-'.concat((itemWidth + 1) * 0.5, 'px');
                                item.style.bottom = (dan[i].isSubtitle ? 0 : bottom) + 'px';
                            }
                            break;
                        default:
                            console.error('无法处理的弹幕模式: '.concat(dan[i].type));
                        }
                        if (tunnel >= 0) {
                            item.classList.add('mfunsPlayer-danmaku-move');
                            item.dataset.id = dan[i].id;
                            if (!!_this10._speed && !dan[i].isSubtitle) {
                                item.classList.add(_this10._speed);
                            }
                            _this10.container.appendChild(item);
                        }
                    };
                    for (var i = 0; i < dan.length; i++) {
                        var _ret2 = _loop2();
                        if (_ret2 === 'continue')
                            continue;
                        if (_typeof(_ret2) === 'object')
                            return _ret2.v;
                    }
                }
            }
        },
        {
            key: 'removeDanmakuCheck',
            value: function removeDanmakuCheck() {
                this.lockDanmaku && this.lockDanmaku.classList.remove('lock');
                this.player.template.danmakuTip.classList.remove('show');
                this.lockDanmaku.dataset.moved = 0;
                this.lockDanmaku.style.zIndex = 'auto';
                this.container.style.cursor = 'none';
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
            }
        },
        {
            key: '_measure',
            value: function _measure(text, size) {
                var _measureStyle$getProp;
                if (!this.demoDanmaku) {
                    this.demoDanmaku = this.container.getElementsByClassName('mfunsPlayer-danmaku-item')[0];
                }
                this.demoDanmaku.style.fontSize = (this.miniMode ? 16 : size) * this._fontScale + 'px';
                var measureStyle = getComputedStyle(this.demoDanmaku, false);
                if (!this.context) {
                    this.context = document.createElement('canvas').getContext('2d');
                }
                var fontSize = measureStyle.getPropertyValue('font-size');
                var fontWeight = measureStyle.getPropertyValue('font-weight');
                var fontFamily = measureStyle.getPropertyValue('font-family');
                this.context.font = (_measureStyle$getProp = measureStyle.getPropertyValue('font')) !== null && _measureStyle$getProp !== void 0 ? _measureStyle$getProp : ''.concat(fontWeight, '  ').concat(fontSize, ' / ').concat(fontSize, ' ').concat(fontFamily);
                return this.context.measureText(text).width;
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.clear();
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].time >= this.options.time()) {
                        this.danIndex = i;
                        console.log('danmaku-start-index', i);
                        break;
                    }
                    this.danIndex = this.dan.length;
                }
            }
        },
        {
            key: 'clear',
            value: function clear(type) {
                if (type) {
                    this.danTunnel[type] = {};
                    return;
                }
                this.danTunnel = {
                    left: {},
                    right: {},
                    top: {},
                    bottom: {}
                };
                this.danIndex = 0;
                this.options.container.innerHTML = '';
                this.options.container.appendChild(this.demoDanmaku);
                this.events && this.events.trigger('danmaku_clear');
            }
        },
        {
            key: 'htmlEncode',
            value: function htmlEncode(str) {
                return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
            }
        },
        {
            key: 'resize',
            value: function resize() {
                var danWidth = this.container.offsetWidth;
                var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-right');
                for (var i = 0; i < items.length; i++) {
                    items[i].style.transform = 'translateX(-'.concat(danWidth, 'px)');
                }
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.showing = false;
                this.pause();
                this.clear();
                this.events && this.events.trigger('danmaku_hide');
                this.events && this.events.trigger('setDanmaku', {
                    key: 'show',
                    value: false
                });
            }
        },
        {
            key: 'show',
            value: function show() {
                this.seek();
                this.showing = true;
                this.play();
                this.events && this.events.trigger('danmaku_show');
                this.events && this.events.trigger('setDanmaku', {
                    key: 'show',
                    value: true
                });
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.showing) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        {
            key: 'unlimit',
            value: function unlimit(_boolean) {
                this.unlimited = _boolean;
            }
        },
        {
            key: 'mini',
            value: function mini(flag) {
                this.miniMode = flag;
                this.options.height = flag ? 22 : 31;
            }
        }
    ]);
    return Danmaku;
}();
export default Danmaku;